import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from { transform: translateY(-50px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1100;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(3px);
`;

export const FormContainer = styled.div`
  background: #252525;
  width: 500px;
  padding: 30px;
  border-radius: 8px;
  border: 1px solid #e6aa3a;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  animation: ${slideIn} 0.3s ease;
`;

export const Title = styled.h3`
  color: #e6aa3a;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
  font-size: 22px;
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;

  label {
    display: block;
    color: #ccc;
    margin-bottom: 5px;
    font-size: 14px;
  }

  input,
  select,
  textarea {
    width: 100%;
    padding: 10px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid #444;
    border-radius: 4px;
    color: #fff;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }

  textarea {
    resize: vertical;
    min-height: 80px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  gap: 10px;
`;

export const CancelButton = styled.button`
  flex: 1;
  background: transparent;
  border: 1px solid #555;
  color: #ccc;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const SubmitButton = styled.button`
  flex: 1;
  background: #e6aa3a;
  border: none;
  color: #111;
  font-weight: bold;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #ffc300;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ToggleGroup = styled.div`
  display: flex;
  margin-bottom: 20px;
  background: #111;
  border-radius: 6px;
  padding: 4px;
`;

export const ToggleOption = styled.div`
  flex: 1;
  text-align: center;
  padding: 8px;
  cursor: pointer;
  font-weight: 600;
  border-radius: 4px;
  font-size: 14px;
  color: ${(props) => (props.active ? "#111" : "#777")};
  background: ${(props) => (props.active ? "#E6AA3A" : "transparent")};
  transition: all 0.2s;
`;

export const InputWithIcon = styled.div`
  position: relative;

  input {
    padding-right: 40px; /* Espaço para o ícone */
  }

  button {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 40px;
    background: transparent;
    border: none;
    color: #e6aa3a;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #fff;
    }
  }
`;
